import { motion } from "framer-motion";
import { FC } from "react";
import { blobAnimation } from "utils/motionPresets";

export interface BgGlassmorphismProps {
  className?: string;
}

const BgGlassmorphism: FC<BgGlassmorphismProps> = ({
  className = "absolute inset-x-0 md:top-10 xl:top-40 min-h-0 pl-20 py-24 flex overflow-hidden z-0",
}) => {
  return (
    <div
      className={`nc-BgGlassmorphism ${className}`}
      data-nc-id="BgGlassmorphism"
    >
      <motion.span
        className="block bg-secondary2-500 w-72 h-72 rounded-full mix-blend-multiply filter blur-3xl opacity-15 lg:w-96 lg:h-96 dark:opacity-10"
        {...blobAnimation}
      />
      <motion.span
        className="block bg-primary-500 w-72 h-72 -ml-20 mt-40 rounded-full mix-blend-multiply filter blur-3xl opacity-15 lg:w-96 lg:h-96 dark:opacity-10"
        animate={{
          scale: [1, 1.2, 1],
          x: [0, -20, 0],
          y: [0, 15, 0],
          transition: { duration: 10, repeat: Infinity, ease: "easeInOut" },
        }}
      />
      <motion.span
        className="hidden lg:block bg-primary-300 w-48 h-48 ml-40 -mt-20 rounded-full mix-blend-multiply filter blur-3xl opacity-10"
        animate={{
          scale: [1, 1.1, 1],
          transition: { duration: 6, repeat: Infinity, ease: "easeInOut", delay: 2 },
        }}
      />
    </div>
  );
};

export default BgGlassmorphism;
